
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dj",
      function () {
        return require("private-next-pages/dj/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dj"])
      });
    }
  